import { Injectable, inject } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ErrorService } from './error.service';

/**
 * Global HTTP error interceptor. Catches all HTTP errors and delegates them
 * to the {@link ErrorService} for user-facing handling (snackbars, redirects, etc.).
 *
 * Requests can opt out of this global error handling by setting the
 * `X-Skip-Error-Interceptor` header. This is useful when a request has its own
 * error handling strategy (e.g. retries with graceful degradation) and should not
 * trigger user-facing error notifications. The header is stripped before the
 * request is sent to the server.
 *
 * @see TdsWizardService#getCardataToken — uses this opt-out for token fetches that
 *   may fail due to race conditions and are retried silently.
 */
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private errorService = inject(ErrorService);


  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (req.headers.has('X-Skip-Error-Interceptor')) {
      const cleanReq = req.clone({ headers: req.headers.delete('X-Skip-Error-Interceptor') });
      return next.handle(cleanReq);
    }
    return next.handle(req).pipe(
      tap(
        (_: HttpEvent<any>) => {
          // success
        },
        (error: any) => {
          this.errorService.handleError(error);
        },
      ),
    );
  }
}
